import {ToastPlugin, ModalPlugin} from 'bootstrap-vue'
import Vue from 'vue'

Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
